import portalApi from "../api/apiSlice";

const videosApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "videos",
    }),

    getSingleVideo: builder.query({
      query: (videoId) => `videos/${videoId}`,
    }),

    addVideo: builder.mutation({
      query: (video) => ({
        url: "videos",
        method: "POST",
        body: video,
      }),

      onQueryStarted: async (video, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            portalApi.util.updateQueryData(
              "getVideos",
              undefined,
              (prevVideos) => {
                return [...prevVideos, data];
              }
            )
          );
        } catch {}
      },
    }),

    editVideo: builder.mutation({
      query: (video) => ({
        url: `videos/${video.id}`,
        method: "PATCH",
        body: video,
      }),

      onQueryStarted: async (video, { dispatch, queryFulfilled }) => {
        let updateGetVideos;
        let updateGetSingleVideos;

        try {
          const { data } = await queryFulfilled;

          updateGetVideos = dispatch(
            portalApi.util.updateQueryData(
              "getVideos",
              undefined,
              (prevVideos) => {
                return prevVideos.map((prevVideo) => {
                  if (prevVideo.id === video.id) {
                    return data;
                  }
                  return prevVideo;
                });
              }
            )
          );

          updateGetSingleVideos = dispatch(
            portalApi.util.updateQueryData("getSingleVideo", video.id, () => {
              return data;
            })
          );
        } catch (error) {
          updateGetVideos.undo();
          updateGetSingleVideos.undo();
        }
      },
    }),

    deleteVideo: builder.mutation({
      query: (videoId) => ({
        url: `videos/${videoId}`,
        method: "DELETE",
      }),

      onQueryStarted: async (videoId, { dispatch, queryFulfilled }) => {
        let updateGetVideos;

        try {
          await queryFulfilled;
          updateGetVideos = dispatch(
            portalApi.util.updateQueryData(
              "getVideos",
              undefined,
              (prevVideos) => {
                return prevVideos.filter((prevVideo) => {
                  return prevVideo.id !== videoId;
                });
              }
            )
          );
        } catch (error) {
          updateGetVideos.undo();
        }
      },
    }),
  }),
});

export const {
  useDeleteVideoMutation,
  useGetSingleVideoQuery,
  useGetVideosQuery,
  useAddVideoMutation,
  useEditVideoMutation,
} = videosApi;
